import React, { Component } from 'react';
import ReactGA from 'react-ga';

class Colophon extends Component {
  render() {
    ReactGA.initialize('UA-68424037-1');
    return (
      <div className="grid">
        <div className="grid-item-wide">
          <div className="element">
            <h1 className="title">Colophon</h1>
          </div>
        </div>


        <div className="grid-item two-grid-item-two three-grid-item-two four-grid-item-two five-grid-item-two">
          <div className="element">
            <p>
              This website is a very simple React app. It's hosted on <a href="https://www.netlify.com">Netlify</a>.
            </p>

            <p>
              It's on a custom grid, with no CSS frameworks.<br />
              The typeface is <a href="https://www.google.com/fonts/specimen/Libre+Baskerville">Libre Baskerville</a> by <a href="http://www.impallari.com/">Impallari Type</a>.
            </p>

            <p>
              <a href="https://git-scm.com/">Git</a> &amp; <a href="https://www.github.com">Github</a> is used for version control.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Colophon;




// WEBPACK FOOTER //
// ./src/pages/Colophon/index.js